/* 
*  Copyright (c) Microsoft. All rights reserved. Licensed under the MIT license. 
*  See LICENSE in the source repository root for complete license information. 
*/

// This sample uses an open source OAuth 2.0 library that is compatible with the Azure AD v2.0 endpoint. 
// Microsoft does not provide fixes or direct support for this library. 
// Refer to the library’s repository to file issues or for other support. 
// For more information about auth libraries see: https://azure.microsoft.com/documentation/articles/active-directory-v2-libraries/ 
// Library repo: https://github.com/MrSwitch/hello.js

import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import * as hello from 'hellojs/dist/hello.all.js';
import { Observable, from } from 'rxjs'
import { Configs } from '../shared/configs';
import { HttpService  } from '../shared/http.service';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  appInsights: ApplicationInsights;
  constructor(
    private zone: NgZone,
    private router: Router,
    private sharedService: HttpService
  ) { 

     this.appInsights= new ApplicationInsights({ config: {
      instrumentationKey: '07146836-91bf-451f-a61c-fb1122f9f23e'
      /* ...Other Configuration Options... */
    } });
    this.appInsights.loadAppInsights();
    this.appInsights.trackPageView(); 
  }

  public memberOfAdminOk(): Observable<any> {
    return new Observable(obs => {
        this.sharedService.client.api('me/memberOf').get().then(res => {

                console.log("MEMBER ADMIN VALIDATOR")
                console.log(res)
                //this.appInsights.trackEvent({ name: "POLITICAS", },{user:"User01"});
                this.appInsights.trackEvent({ name: "PORTAL_POLITICAS"});
                //debugger;
                res.value.map(x=>{ console.log(x) })

            let fd = res.value.filter(e => e["@odata.type"] === "#microsoft.graph.directoryRole" && e.roleTemplateId === '62e90394-69f5-4237-9190-012177145e10');
            obs.next(fd.length > 0);
            obs.complete();
        }).catch(error => {
          console.log("[ERROR AUTH]===>>");
          console.log(error.statusCode);
          if (error.statusCode==401) {
              this.logout()
          }if (error.statusCode===-1) {
            console.log("[ERROR AUTH]: -1 ===>>");
            //this.logout();
            window.location.href = '/';
          }
      });
    });
}

  initAuth() {
    hello.init({
        msft: {
          id: Configs.appId,
          oauth: {
            version: 2,
            auth: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize'
          },
          scope_delim: ' ',
          form: false
        },
      },
      { redirect_uri: window.location.href }
    );
  }

  login() {
    hello('msft').login({ scope: Configs.scope }).then(
      () => {
        this.zone.run(() => {
          this.router.navigate(['/politicas']);
        });
      },
      e => console.error(e.error.message)
    );
  }

  logout() {
    hello('msft').logout().then(
      () => window.location.href = '/',
      e => console.error(e.error.message)
    );
  }
}
